var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('HeaderComponent'),_c('HeroComponent'),_c('BrandsComponent'),_c('AppFeatureComponent'),_c('JackpotComponent'),_c('DesignComponent'),_c('ReasonComponent'),_c('FAQComponent'),_c('FooterComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }